import React from "react";
import { SectionFrame } from "../atoms/SectionFrame";
import { ParticleField } from "../atoms/ParticleField";
import { GlowLine } from "../atoms/GlowLine";
import { TID } from "../../lib/testIds";

export function FooterSection() {
    return (
        <SectionFrame innerClassName="" className="pb-10 md:pb-16">
            <div className="relative">
                <div className="absolute inset-0 pointer-events-none opacity-70">
                    <ParticleField density={0.25} influence="none" />
                </div>

                <div className="relative pt-12 pb-8 px-6 md:px-12">
                    <GlowLine className="mb-10" />
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
                        <div className="flex items-baseline gap-8 md:gap-12 flex-wrap">
                            <span className="display-text font-black uppercase tracking-tight"
                                  style={{ fontSize: "clamp(1.4rem, 3vw, 2rem)", letterSpacing: "-0.02em" }}>
                                GrowCo
                            </span>
                            <span className="text-base uppercase tracking-[0.3em]" style={{ color: "var(--accent)" }}>
                                India
                            </span>
                            <a
                                data-testid={TID.footerLinkLinkedIn}
                                href="https://www.linkedin.com/company/growcomotion/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-base uppercase tracking-[0.3em] hover:text-[var(--accent)] transition-colors"
                                style={{ color: "var(--muted)" }}
                            >
                                LinkedIn
                            </a>
                            <a
                                data-testid={TID.footerLinkEmail}
                                href="mailto:team@grow-co.net"
                                className="text-base uppercase tracking-[0.3em] hover:text-[var(--accent)] transition-colors"
                                style={{ color: "var(--muted)" }}
                            >
                                Email
                            </a>
                        </div>
                        <a
                            data-testid={TID.footerLinkCreator}
                            href="https://www.grow-co.net/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center justify-center gap-2 rounded-full border-2 px-5 py-3 md:px-6 text-xs md:text-sm uppercase tracking-[0.18em] md:tracking-[0.2em] font-medium transition-colors hover:bg-white/5 text-center w-full md:w-auto md:whitespace-nowrap"
                            style={{ color: "var(--text)", borderColor: "var(--line)" }}
                            onMouseEnter={(e) => { e.currentTarget.style.borderColor = "var(--accent)"; e.currentTarget.style.boxShadow = "0 0 24px var(--accent-soft)"; }}
                            onMouseLeave={(e) => { e.currentTarget.style.borderColor = "var(--line)"; e.currentTarget.style.boxShadow = "none"; }}
                        >
                            Looking for Post Production? Check out GrowCo →
                        </a>
                    </div>
                    <div className="mt-10 flex flex-col md:flex-row md:items-center md:justify-between gap-3 md:gap-4 text-xs md:text-sm uppercase tracking-[0.25em]">
                        <span style={{ color: "var(--muted)", opacity: 0.6 }}>© 2024 GrowCo Motion - Tondku LLP</span>
                        <span
                            className="font-bold"
                            style={{
                                color: "var(--accent)",
                                textShadow: "0 0 18px var(--accent-soft)",
                            }}
                        >
                            Ideas Deserve Motion
                        </span>
                    </div>
                </div>
            </div>
        </SectionFrame>
    );
}
